import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUnlockAlt, faTrash } from "@fortawesome/free-solid-svg-icons";
import { useDispatch, useSelector } from "react-redux";
import toast from "react-hot-toast";
import {
  EMAIL_REGEX,
  positiveDigitsRegex,
  tenDigitRegexStartingWith9,
} from "../../helpers/regexHelper";

import { useForm, Controller } from "react-hook-form";
import Datetime from "react-datetime";
import { faCalendarAlt } from "@fortawesome/free-solid-svg-icons";
import dayjs from "dayjs";
import { familyTypeOptions, relationOptions } from "../../helpers/Constants";

import {
  Form,
  Card,
  Col,
  InputGroup,
  Button,
  Row,
  Spinner,
} from "@themesberg/react-bootstrap";
import {
  assignToCollector,
  clearIndividualCustomer,
  createCustomer,
  getCustomerById,
  updateCustomer,
} from "../../redux/actions/customer";
import CustomDashboardLoader from "../../components/CustomDashboardLoader";
import CustomErrorView from "../../components/CustomErrorView";
import { getCollectors } from "../../redux/actions/collector";
import CollectorHelper from "../../helpers/CollectorHelper";

const initialErrors = {
  errorName: "",
  errorPhone: "",
  errorLocation: "",
  errorBusinessType: "",
};
const initialValues = {
  name: "",
  phone: "",
  location: "",
  businessType: "",
};

function EditCustomer({ match }) {
  const dispatch = useDispatch();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [values, setValues1] = useState(initialValues);
  const [collectorVal, setCollectorVal] = useState(null);
  const [errors2, setErrors] = useState(initialErrors);
  const [isLoading, setIsLoading] = useState(false);
  const [showErrPage, setShowErrPage] = useState(false);
  const [customerId, setCustomerId] = useState("");
  const [isCollectorLoading, setIsCollectorLoading] = useState(false);
  const [changedCollectorData, setChangedCollectorData] = useState([]);

  const collectorData = useSelector((state) => state.collector.collectorData);
  const individualCustomer = useSelector(
    (state) => state.customer.individualCustomer
  );

  const {
    register,
    handleSubmit,
    watch,
    control,
    formState: { errors },
    setValue,
    reset,
  } = useForm({
    // defaultValues: individualCustomer,
  });

  React.useEffect(() => {
    reset(individualCustomer);
  }, [individualCustomer, reset]);

  const loadSuccess = (responseData) => {
    const initialObject = {
      name: responseData.name,
      phone: responseData.mobileNumber,
      location: responseData.location,
      businessType: responseData.businessType,
    };

    setValues1(initialObject);
    setCustomerId(responseData.customerId);
    setCollectorVal(responseData.assignedCollectorId);
    setIsLoading(false);
  };
  const loadFailiure = () => {
    setIsLoading(false);
    setShowErrPage(true);
  };

  useEffect(() => {
    const tempArr = CollectorHelper(collectorData);
    setChangedCollectorData(tempArr);
  }, [collectorData]);

  useEffect(() => {
    const someId = match.params?.id;
    if (!someId) {
      setShowErrPage(true);
    } else {
      setIsLoading(true);
      setIsCollectorLoading(true);
      dispatch(getCustomerById(someId, loadSuccess, loadFailiure));
      dispatch(getCollectors(true)).then(() => setIsCollectorLoading(false));
    }
    return () => {
      dispatch(clearIndividualCustomer());
    };
  }, []);

  const handleSuccess = () => {
    setIsSubmitting(false);
  };
  const handleFaliure = (e) => {
    setIsSubmitting(false);
  };

  const onChange = (e) => {
    setValues1({ ...values, [e.target.name]: e.target.value });
  };
  const errorHandler = (key, val) => {
    setErrors((current) => {
      return { ...current, [key]: val };
    });
  };

  const onSubmit = (data) => {
    // console.log(data);
    setIsSubmitting(true);
    dispatch(updateCustomer(data, handleSuccess, handleFaliure));
  };

  const submitHandler2 = () => {
    if (collectorVal === null) {
      toast.error("Somthing went wrong. Please select a collector first");
    } else if (collectorVal === "") {
      toast.error("Somthing went wrong. Please select a collector first");
    } else {
      setIsSubmitting(true);
      const data = {
        collectorId: collectorVal,
        customerIdList: [customerId],
      };
      dispatch(assignToCollector(data)).then(() => setIsSubmitting(false));
    }
  };

  if (showErrPage) {
    return <CustomErrorView />;
  } else {
    return (
      <>
        {isLoading ? (
          <CustomDashboardLoader />
        ) : (
          <>
            <Col md={12} className={"mt-3"}>
              <Card border="light" className="bg-white shadow-sm mb-4 p-0">
                <Card.Body>
                  <div
                    className="d-flex"
                    style={{
                      // background: "red",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    <h5>Edit Customer Info</h5>
                    <Button variant="danger" size="sm">
                      <FontAwesomeIcon icon={faTrash} className="me-1" /> Delete
                      Customer
                    </Button>
                  </div>

                  <Form onSubmit={handleSubmit(onSubmit)}>
                    <h5 className="mb-4">General Information</h5>
                    <Row>
                      <Col md={6} className="mb-3">
                        <Form.Group className="mb-3">
                          <Form.Label>Account Name</Form.Label>
                          <Form.Control
                            {...register("accountName", {
                              required: "This is required",
                              minLength: {
                                value: 4,
                                message: "Min Length is 4",
                              },
                            })}
                            type="text"
                            placeholder=""
                            size="sm"
                            disabled
                          />

                          {errors.accountName && (
                            <Form.Text className="text-danger">
                              {errors.accountName.message}
                            </Form.Text>
                          )}
                        </Form.Group>
                      </Col>
                      <Col md={6} className="mb-3">
                        <Form.Group className="mb-3">
                          <Form.Label>Date of Account Creation</Form.Label>

                          <Controller
                            control={control}
                            name="dateOfAccountCreation"
                            render={({ field }) => (
                              <Datetime
                                timeFormat={false}
                                placeholderText="Select date"
                                onChange={(date) => field.onChange(date)}
                                selected={field.value}
                                renderInput={(props, openCalendar) => {
                                  return (
                                    <InputGroup>
                                      <InputGroup.Text>
                                        <FontAwesomeIcon icon={faCalendarAlt} />
                                      </InputGroup.Text>
                                      <Form.Control
                                        {...register("dateOfAccountCreation", {
                                          required: "This is required",
                                        })}
                                        required
                                        type="text"
                                        value={
                                          field.value
                                            ? dayjs(field.value).format(
                                                "YYYY/MM/DD"
                                              )
                                            : ""
                                        }
                                        placeholder="yyyy/mm/dd"
                                        onFocus={openCalendar}
                                        autocomplete="off"
                                        size="sm"
                                      />
                                    </InputGroup>
                                  );
                                }}
                              />
                            )}
                          />

                          {errors.dateOfAccountCreation && (
                            <Form.Text className="text-danger">
                              {errors.dateOfAccountCreation.message}
                            </Form.Text>
                          )}
                        </Form.Group>
                      </Col>
                      <Col md={3} className="mb-3">
                        <Form.Group className="mb-3">
                          <Form.Label>Date of Birth</Form.Label>

                          <Controller
                            control={control}
                            name="dateOfBirth"
                            render={({ field }) => (
                              <Datetime
                                timeFormat={false}
                                placeholderText="Select date"
                                onChange={(date) => field.onChange(date)}
                                selected={field.value}
                                renderInput={(props, openCalendar) => {
                                  return (
                                    <InputGroup>
                                      <InputGroup.Text>
                                        <FontAwesomeIcon icon={faCalendarAlt} />
                                      </InputGroup.Text>
                                      <Form.Control
                                        {...register("dateOfBirth", {
                                          required: "This is required",
                                        })}
                                        required
                                        type="text"
                                        value={
                                          field.value
                                            ? dayjs(field.value).format(
                                                "YYYY/MM/DD"
                                              )
                                            : ""
                                        }
                                        placeholder="yyyy/mm/dd"
                                        onFocus={openCalendar}
                                        autocomplete="off"
                                        size="sm"
                                      />
                                    </InputGroup>
                                  );
                                }}
                              />
                            )}
                          />

                          {errors.dateOfBirth && (
                            <Form.Text className="text-danger">
                              {errors.dateOfBirth.message}
                            </Form.Text>
                          )}
                        </Form.Group>
                      </Col>
                      <Col md={3} className="mb-3">
                        <Form.Group className="mb-3">
                          <Form.Label>Occupation</Form.Label>
                          <Form.Control
                            {...register("occupation", {
                              required: "This is required",
                              minLength: {
                                value: 4,
                                message: "Min Length is 4",
                              },
                            })}
                            type="text"
                            placeholder=""
                            size="sm"
                          />

                          {errors.occupation && (
                            <Form.Text className="text-danger">
                              {errors.occupation.message}
                            </Form.Text>
                          )}
                        </Form.Group>
                      </Col>
                      <Col md={3} className="mb-3">
                        <Form.Group className="mb-3">
                          <Form.Label>Gender</Form.Label>

                          <Form.Select
                            aria-label="Default select example"
                            {...register("gender", {
                              required: "This is required",
                            })}
                            size="sm"
                          >
                            <option value={null}>{null}</option>
                            <option value={"Male"}>{"Male"}</option>
                            <option value={"Female"}>{"Female"}</option>
                          </Form.Select>

                          {errors.gender && (
                            <Form.Text className="text-danger">
                              {errors.gender.message}
                            </Form.Text>
                          )}
                        </Form.Group>
                      </Col>
                      <Col md={3} className="mb-3">
                        <Form.Group className="mb-3">
                          <Form.Label>Nationality</Form.Label>
                          <Form.Control
                            {...register("nationality", {
                              required: "This is required",
                              minLength: {
                                value: 4,
                                message: "Min Length is 4",
                              },
                            })}
                            type="text"
                            placeholder=""
                            size="sm"
                          />

                          {errors.nationality && (
                            <Form.Text className="text-danger">
                              {errors.nationality.message}
                            </Form.Text>
                          )}
                        </Form.Group>
                      </Col>
                      <Col md={3} className="mb-3">
                        <Form.Group className="mb-3">
                          <Form.Label>Email</Form.Label>
                          <Form.Control
                            {...register("mailEmail", {
                              required: "This is required",
                              pattern: {
                                value: EMAIL_REGEX,
                                message: "Please enter correct email.",
                              },
                            })}
                            type="email"
                            placeholder=""
                            size="sm"
                          />

                          {errors.mailEmail && (
                            <Form.Text className="text-danger">
                              {errors.mailEmail.message}
                            </Form.Text>
                          )}
                        </Form.Group>
                      </Col>
                      <Col md={3} className="mb-3">
                        <Form.Group className="mb-3">
                          <Form.Label>Mobile Number</Form.Label>
                          <Form.Control
                            {...register("mailMobileNumber", {
                              required: "This is required",
                              pattern: {
                                value: tenDigitRegexStartingWith9,
                                message: "Mobile number should be 10digits",
                              },
                            })}
                            type="text"
                            placeholder=""
                            size="sm"
                          />

                          {errors.mailMobileNumber && (
                            <Form.Text className="text-danger">
                              {errors.mailMobileNumber.message}
                            </Form.Text>
                          )}
                        </Form.Group>
                      </Col>

                      <Col md={3} className="mb-3">
                        <Form.Group className="mb-3">
                          <Form.Label>Residence Phone</Form.Label>
                          <Form.Control
                            {...register("mailResidencePhone", {
                              minLength: {
                                value: 7,
                                message:
                                  "Phone number should be atleast 7 digits ",
                              },
                              pattern: {
                                value: positiveDigitsRegex,
                                message: "Phone number should be digits only",
                              },
                            })}
                            type="text"
                            placeholder=""
                            size="sm"
                          />

                          {errors.mailResidencePhone && (
                            <Form.Text className="text-danger">
                              {errors.mailResidencePhone.message}
                            </Form.Text>
                          )}
                        </Form.Group>
                      </Col>

                      <Col md={3} className="mb-3">
                        <Form.Group className="mb-3">
                          <Form.Label>Firm Residence Type</Form.Label>
                          <Form.Control
                            {...register("firmResidenceType", {
                              minLength: {
                                value: 3,
                                message: "Min Length is 3",
                              },
                            })}
                            type="text"
                            placeholder=""
                            size="sm"
                          />

                          {errors.firmResidenceType && (
                            <Form.Text className="text-danger">
                              {errors.firmResidenceType.message}
                            </Form.Text>
                          )}
                        </Form.Group>
                      </Col>

                      <Col md={6} className="mb-3">
                        <Form.Group className="mb-3">
                          <Form.Label>Citizenship Number</Form.Label>
                          <Form.Control
                            {...register("citizenshipNumber", {
                              required: "This is required",
                            })}
                            type="text"
                            placeholder=""
                            size="sm"
                          />

                          {errors.citizenshipNumber && (
                            <Form.Text className="text-danger">
                              {errors.citizenshipNumber.message}
                            </Form.Text>
                          )}
                        </Form.Group>
                      </Col>

                      <Col md={6} className="mb-3">
                        <Form.Group className="mb-3">
                          <Form.Label>Citizenship Issuing District</Form.Label>
                          <Form.Control
                            {...register("citizenshipIssuingDistrict", {
                              required: "This is required",
                              minLength: {
                                value: 4,
                                message: "Min Length is 4",
                              },
                            })}
                            type="text"
                            placeholder=""
                            size="sm"
                          />

                          {errors.citizenshipIssuingDistrict && (
                            <Form.Text className="text-danger">
                              {errors.citizenshipIssuingDistrict.message}
                            </Form.Text>
                          )}
                        </Form.Group>
                      </Col>

                      <Col md={3} className="mb-3">
                        <Form.Group className="mb-3">
                          <Form.Label>Voter Card Number</Form.Label>
                          <Form.Control
                            {...register("voterCardNumber", {})}
                            type="text"
                            placeholder=""
                            size="sm"
                          />

                          {errors.voterCardNumber && (
                            <Form.Text className="text-danger">
                              {errors.voterCardNumber.message}
                            </Form.Text>
                          )}
                        </Form.Group>
                      </Col>
                      <Col md={3} className="mb-3">
                        <Form.Group className="mb-3">
                          <Form.Label>Voting Area</Form.Label>
                          <Form.Control
                            {...register("votingArea", {
                              minLength: {
                                value: 4,
                                message: "Min Length is 4",
                              },
                            })}
                            type="text"
                            placeholder=""
                            size="sm"
                          />

                          {errors.votingArea && (
                            <Form.Text className="text-danger">
                              {errors.votingArea.message}
                            </Form.Text>
                          )}
                        </Form.Group>
                      </Col>
                      <Col md={3} className="mb-3">
                        <Form.Group className="mb-3">
                          <Form.Label>Passport Number</Form.Label>
                          <Form.Control
                            {...register("passportNumber", {
                              minLength: {
                                value: 4,
                                message: "Min Length is 4",
                              },
                            })}
                            type="text"
                            placeholder=""
                            size="sm"
                          />

                          {errors.passportNumber && (
                            <Form.Text className="text-danger">
                              {errors.passportNumber.message}
                            </Form.Text>
                          )}
                        </Form.Group>
                      </Col>
                      <Col md={3} className="mb-3">
                        <Form.Group className="mb-3">
                          <Form.Label>Driving License Number</Form.Label>
                          <Form.Control
                            {...register("drivingLicenseNumber", {})}
                            type="text"
                            placeholder=""
                            size="sm"
                          />

                          {errors.drivingLicenseNumber && (
                            <Form.Text className="text-danger">
                              {errors.drivingLicenseNumber.message}
                            </Form.Text>
                          )}
                        </Form.Group>
                      </Col>

                      <Col md={6} className="mb-3">
                        <Form.Group className="mb-3">
                          <Form.Label>Office Name</Form.Label>
                          <Form.Control
                            {...register("mailOfficeName", {
                              minLength: {
                                value: 4,
                                message: "Min Length is 4",
                              },
                            })}
                            type="text"
                            placeholder=""
                            size="sm"
                          />

                          {errors.mailOfficeName && (
                            <Form.Text className="text-danger">
                              {errors.mailOfficeName.message}
                            </Form.Text>
                          )}
                        </Form.Group>
                      </Col>
                      <Col md={6} className="mb-3">
                        <Form.Group className="mb-4">
                          <Form.Label>Office Phone</Form.Label>
                          <InputGroup>
                            <InputGroup.Text>
                              <FontAwesomeIcon icon={faUnlockAlt} />
                            </InputGroup.Text>
                            <Form.Control
                              required
                              type="number"
                              placeholder=""
                              {...register("mailOfficePhone")}
                              size="sm"
                            />
                          </InputGroup>
                          {errors.mailOfficePhone && (
                            <Form.Text className="text-danger">
                              {errors.mailOfficePhone.message}
                            </Form.Text>
                          )}
                        </Form.Group>
                      </Col>
                      <hr />
                      <h5 className="mb-4">Family Details</h5>

                      <Col md={4} className="mb-3">
                        <Form.Group className="mb-3">
                          <Form.Label>Father's Name</Form.Label>
                          <Form.Control
                            {...register("fatherName", {
                              required: "This is required",
                              minLength: {
                                value: 4,
                                message: "Min Length is 4",
                              },
                            })}
                            type="text"
                            placeholder=""
                            size="sm"
                          />

                          {errors.fatherName && (
                            <Form.Text className="text-danger">
                              {errors.fatherName.message}
                            </Form.Text>
                          )}
                        </Form.Group>
                      </Col>
                      <Col md={4} className="mb-3">
                        <Form.Group className="mb-3">
                          <Form.Label>Father's Age</Form.Label>
                          <Form.Control
                            {...register("fatherAge", {
                              minLength: {
                                value: 1,
                                message: "Min Length is 1",
                              },
                              pattern: {
                                value: positiveDigitsRegex,
                                message: "Should be a positve number",
                              },
                            })}
                            type="number"
                            placeholder=""
                            size="sm"
                          />

                          {errors.fatherAge && (
                            <Form.Text className="text-danger">
                              {errors.fatherAge.message}
                            </Form.Text>
                          )}
                        </Form.Group>
                      </Col>
                      <Col md={4} className="mb-3">
                        <Form.Group className="mb-3">
                          <Form.Label>Father's Occupation</Form.Label>
                          <Form.Control
                            {...register("fatherOccupation", {
                              minLength: {
                                value: 4,
                                message: "Min Length is 4",
                              },
                            })}
                            type="text"
                            placeholder=""
                            size="sm"
                          />

                          {errors.fatherOccupation && (
                            <Form.Text className="text-danger">
                              {errors.fatherOccupation.message}
                            </Form.Text>
                          )}
                        </Form.Group>
                      </Col>
                      <Col md={4} className="mb-3">
                        <Form.Group className="mb-3">
                          <Form.Label>Mother's Name</Form.Label>
                          <Form.Control
                            {...register("motherName", {
                              required: "This is required",
                              minLength: {
                                value: 4,
                                message: "Min Length is 4",
                              },
                            })}
                            type="text"
                            placeholder=""
                            size="sm"
                          />

                          {errors.motherName && (
                            <Form.Text className="text-danger">
                              {errors.motherName.message}
                            </Form.Text>
                          )}
                        </Form.Group>
                      </Col>
                      <Col md={4} className="mb-3">
                        <Form.Group className="mb-3">
                          <Form.Label>Mother's Age</Form.Label>
                          <Form.Control
                            {...register("motherAge", {
                              minLength: {
                                value: 1,
                                message: "Min Length is 1",
                              },
                              pattern: {
                                value: positiveDigitsRegex,
                                message: "Should be a positve number",
                              },
                            })}
                            type="number"
                            placeholder=""
                            size="sm"
                          />

                          {errors.motherAge && (
                            <Form.Text className="text-danger">
                              {errors.motherAge.message}
                            </Form.Text>
                          )}
                        </Form.Group>
                      </Col>
                      <Col md={4} className="mb-3">
                        <Form.Group className="mb-3">
                          <Form.Label>Mother's Occupation</Form.Label>
                          <Form.Control
                            {...register("motherOccupation", {
                              minLength: {
                                value: 4,
                                message: "Min Length is 4",
                              },
                            })}
                            type="text"
                            placeholder=""
                            size="sm"
                          />

                          {errors.motherOccupation && (
                            <Form.Text className="text-danger">
                              {errors.motherOccupation.message}
                            </Form.Text>
                          )}
                        </Form.Group>
                      </Col>
                      <Col md={4} className="mb-3">
                        <Form.Group className="mb-3">
                          <Form.Label>Grandfather's Name</Form.Label>
                          <Form.Control
                            {...register("grandFatherName", {
                              required: "This is required",
                              minLength: {
                                value: 4,
                                message: "Min Length is 4",
                              },
                            })}
                            type="text"
                            placeholder=""
                            size="sm"
                          />

                          {errors.grandFatherName && (
                            <Form.Text className="text-danger">
                              {errors.grandFatherName.message}
                            </Form.Text>
                          )}
                        </Form.Group>
                      </Col>

                      <Col md={4} className="mb-3">
                        <Form.Group className="mb-3">
                          <Form.Label>Grandfathers's Age</Form.Label>
                          <Form.Control
                            {...register("grandFatherAge", {
                              minLength: {
                                value: 1,
                                message: "Min Length is 1",
                              },
                              pattern: {
                                value: positiveDigitsRegex,
                                message: "Should be a positve number",
                              },
                            })}
                            type="number"
                            placeholder=""
                            size="sm"
                          />

                          {errors.grandFatherAge && (
                            <Form.Text className="text-danger">
                              {errors.grandFatherAge.message}
                            </Form.Text>
                          )}
                        </Form.Group>
                      </Col>
                      <Col md={4} className="mb-3">
                        <Form.Group className="mb-3">
                          <Form.Label>Grandfather's Occupation</Form.Label>
                          <Form.Control
                            {...register("grandfatherOccupation", {
                              minLength: {
                                value: 4,
                                message: "Min Length is 4",
                              },
                            })}
                            type="text"
                            placeholder=""
                            size="sm"
                          />

                          {errors.grandfatherOccupation && (
                            <Form.Text className="text-danger">
                              {errors.grandfatherOccupation.message}
                            </Form.Text>
                          )}
                        </Form.Group>
                      </Col>
                      <Col md={3} className="mb-3">
                        <Form.Group className="mb-3">
                          <Form.Label>Marital Status</Form.Label>
                          {/* <Form.Control
                    {...register("maritalStatus", {
                      required: "This is required",
                    })}
                    type="text"
                    placeholder=""
                    size="sm"
                  /> */}
                          <Form.Select
                            aria-label="Marital status dropdown"
                            {...register("maritalStatus", {
                              required: "This is required",
                            })}
                            size="sm"
                          >
                            <option value={null}>{null}</option>
                            <option value={"Married"}>{"Married"}</option>
                            <option value={"Unmarried"}>{"Unmarried"}</option>
                          </Form.Select>

                          {errors.maritalStatus && (
                            <Form.Text className="text-danger">
                              {errors.maritalStatus.message}
                            </Form.Text>
                          )}
                        </Form.Group>
                      </Col>
                      {watch().maritalStatus === "Married" ? (
                        <>
                          <Col md={3} className="mb-3">
                            <Form.Group className="mb-3">
                              <Form.Label>Spouse Name</Form.Label>
                              <Form.Control
                                {...register("spouseName", {
                                  minLength: {
                                    value: 4,
                                    message: "Min Length is 4",
                                  },
                                })}
                                type="text"
                                placeholder=""
                                size="sm"
                              />

                              {errors.spouseName && (
                                <Form.Text className="text-danger">
                                  {errors.spouseName.message}
                                </Form.Text>
                              )}
                            </Form.Group>
                          </Col>
                          <Col md={3} className="mb-3">
                            <Form.Group className="mb-3">
                              <Form.Label>Spouse's Age</Form.Label>
                              <Form.Control
                                {...register("spouseAge", {
                                  minLength: {
                                    value: 1,
                                    message: "Min Length is 1",
                                  },
                                  pattern: {
                                    value: positiveDigitsRegex,
                                    message: "Should be a positve number",
                                  },
                                })}
                                type="number"
                                placeholder=""
                                size="sm"
                              />

                              {errors.spouseAge && (
                                <Form.Text className="text-danger">
                                  {errors.spouseAge.message}
                                </Form.Text>
                              )}
                            </Form.Group>
                          </Col>
                          <Col md={3} className="mb-3">
                            <Form.Group className="mb-3">
                              <Form.Label>Spouse's Occupation</Form.Label>
                              <Form.Control
                                {...register("spouseOccupation", {
                                  minLength: {
                                    value: 4,
                                    message: "Min Length is 4",
                                  },
                                })}
                                type="text"
                                placeholder=""
                                size="sm"
                              />

                              {errors.spouseOccupation && (
                                <Form.Text className="text-danger">
                                  {errors.spouseOccupation.message}
                                </Form.Text>
                              )}
                            </Form.Group>
                          </Col>
                        </>
                      ) : (
                        <>
                          <Col md={3} className="mb-3" />
                          <Col md={3} className="mb-3" />
                        </>
                      )}

                      <Col md={4} className="mb-3">
                        <Form.Group className="mb-3">
                          <Form.Label>Children Name</Form.Label>
                          <Form.Control
                            {...register("childrenName", {
                              minLength: {
                                value: 4,
                                message: "Min Length is 4",
                              },
                            })}
                            type="text"
                            placeholder=""
                            size="sm"
                          />

                          {errors.childrenName && (
                            <Form.Text className="text-danger">
                              {errors.childrenName.message}
                            </Form.Text>
                          )}
                        </Form.Group>
                      </Col>

                      <Col md={4} className="mb-3">
                        <Form.Group className="mb-3">
                          <Form.Label>Children's Age</Form.Label>
                          <Form.Control
                            {...register("childrenAge", {
                              pattern: {
                                value: positiveDigitsRegex,
                                message: "Should be a positve number",
                              },
                            })}
                            type="number"
                            placeholder=""
                            size="sm"
                          />

                          {errors.childrenAge && (
                            <Form.Text className="text-danger">
                              {errors.childrenAge.message}
                            </Form.Text>
                          )}
                        </Form.Group>
                      </Col>
                      <Col md={4} className="mb-3">
                        <Form.Group className="mb-3">
                          <Form.Label>Children's Occupation</Form.Label>
                          <Form.Control
                            {...register("childrenOccupation", {
                              minLength: {
                                value: 4,
                                message: "Min Length is 4",
                              },
                            })}
                            type="text"
                            placeholder=""
                            size="sm"
                          />
                          {errors.childrenOccupation && (
                            <Form.Text className="text-danger">
                              {errors.childrenOccupation.message}
                            </Form.Text>
                          )}
                        </Form.Group>
                      </Col>
                      <Col md={4} className="mb-3">
                        <Form.Group className="mb-3">
                          <Form.Label>Family Type</Form.Label>

                          <Form.Select
                            aria-label="Family type dropdown"
                            {...register("familyType", {
                              required: "This is required",
                            })}
                            size="sm"
                          >
                            <option value={null}>{null}</option>
                            {familyTypeOptions.map((item) => (
                              <option key={item.id} value={item.name}>
                                {item.value}
                              </option>
                            ))}
                          </Form.Select>
                          {errors.familyType && (
                            <Form.Text className="text-danger">
                              {errors.familyType.message}
                            </Form.Text>
                          )}
                        </Form.Group>
                      </Col>

                      <hr />
                      <h5 className="mb-4">Address Information</h5>

                      <h7 className="mb-4">Permanent Address</h7>
                      <Col md={4} className="mb-3">
                        <Form.Group className="mb-3">
                          <Form.Label>Zone</Form.Label>
                          <Form.Control
                            {...register("permanentZone", {
                              required: "This is required",
                            })}
                            type="text"
                            placeholder=""
                            size="sm"
                          />
                          {errors.permanentZone && (
                            <Form.Text className="text-danger">
                              {errors.permanentZone.message}
                            </Form.Text>
                          )}
                        </Form.Group>
                      </Col>
                      <Col md={4} className="mb-3">
                        <Form.Group className="mb-3">
                          <Form.Label>District</Form.Label>
                          <Form.Control
                            {...register("permanentDistrict", {
                              required: "This is required",
                            })}
                            type="text"
                            placeholder=""
                            size="sm"
                          />
                          {errors.permanentDistrict && (
                            <Form.Text className="text-danger">
                              {errors.permanentDistrict.message}
                            </Form.Text>
                          )}
                        </Form.Group>
                      </Col>
                      <Col md={4} className="mb-3">
                        <Form.Group className="mb-3">
                          <Form.Label>Municipality</Form.Label>
                          <Form.Control
                            {...register("permanentMunicipality", {
                              required: "This is required",
                              minLength: {
                                value: 4,
                                message: "Min Length is 4",
                              },
                            })}
                            type="text"
                            placeholder=""
                            size="sm"
                          />
                          {errors.permanentMunicipality && (
                            <Form.Text className="text-danger">
                              {errors.permanentMunicipality.message}
                            </Form.Text>
                          )}
                        </Form.Group>
                      </Col>
                      <Col md={4} className="mb-3">
                        <Form.Group className="mb-3">
                          <Form.Label>Ward</Form.Label>
                          <Form.Control
                            {...register("permanentWard", {
                              required: "This is required",
                              minLength: {
                                value: 1,
                                message: "Min Length is 1",
                              },
                            })}
                            type="text"
                            placeholder=""
                            size="sm"
                          />
                          {errors.permanentWard && (
                            <Form.Text className="text-danger">
                              {errors.permanentWard.message}
                            </Form.Text>
                          )}
                        </Form.Group>
                      </Col>
                      <Col md={4} className="mb-3">
                        <Form.Group className="mb-3">
                          <Form.Label>Tole</Form.Label>
                          <Form.Control
                            {...register("permanentTole", {
                              required: "This is required",
                              minLength: {
                                value: 2,
                                message: "Min Length is 2",
                              },
                            })}
                            type="text"
                            placeholder=""
                            size="sm"
                          />
                          {errors.permanentTole && (
                            <Form.Text className="text-danger">
                              {errors.permanentTole.message}
                            </Form.Text>
                          )}
                        </Form.Group>
                      </Col>
                      <Col md={4} className="mb-3">
                        <Form.Group className="mb-3">
                          <Form.Label>House Number</Form.Label>
                          <Form.Control
                            {...register("permanentHouseNumber", {
                              minLength: {
                                value: 1,
                                message: "Min Length is 1",
                              },
                            })}
                            type="text"
                            placeholder=""
                            size="sm"
                          />
                          {errors.permanentHouseNumber && (
                            <Form.Text className="text-danger">
                              {errors.permanentHouseNumber.message}
                            </Form.Text>
                          )}
                        </Form.Group>
                      </Col>

                      <h7 className="mb-4">Temporary Address</h7>
                      <Col md={4} className="mb-3">
                        <Form.Group className="mb-3">
                          <Form.Label>Zone</Form.Label>
                          <Form.Control
                            {...register("temporaryZone", {
                              required: "This is required",
                            })}
                            type="text"
                            placeholder=""
                            size="sm"
                          />
                          {errors.temporaryZone && (
                            <Form.Text className="text-danger">
                              {errors.temporaryZone.message}
                            </Form.Text>
                          )}
                        </Form.Group>
                      </Col>
                      <Col md={4} className="mb-3">
                        <Form.Group className="mb-3">
                          <Form.Label>District</Form.Label>
                          <Form.Control
                            {...register("temporaryDistrict", {
                              required: "This is required",
                            })}
                            type="text"
                            placeholder=""
                            size="sm"
                          />
                          {errors.temporaryDistrict && (
                            <Form.Text className="text-danger">
                              {errors.temporaryDistrict.message}
                            </Form.Text>
                          )}
                        </Form.Group>
                      </Col>
                      <Col md={4} className="mb-3">
                        <Form.Group className="mb-3">
                          <Form.Label>Municipality</Form.Label>
                          <Form.Control
                            {...register("temporaryMunicipality", {
                              required: "This is required",
                              minLength: {
                                value: 4,
                                message: "Min Length is 4",
                              },
                            })}
                            type="text"
                            placeholder=""
                            size="sm"
                          />
                          {errors.temporaryMunicipality && (
                            <Form.Text className="text-danger">
                              {errors.temporaryMunicipality.message}
                            </Form.Text>
                          )}
                        </Form.Group>
                      </Col>
                      <Col md={4} className="mb-3">
                        <Form.Group className="mb-3">
                          <Form.Label>Ward</Form.Label>
                          <Form.Control
                            {...register("temporaryWard", {
                              required: "This is required",
                              minLength: {
                                value: 1,
                                message: "Min Length is 1",
                              },
                            })}
                            type="text"
                            placeholder=""
                            size="sm"
                          />
                          {errors.temporaryWard && (
                            <Form.Text className="text-danger">
                              {errors.temporaryWard.message}
                            </Form.Text>
                          )}
                        </Form.Group>
                      </Col>
                      <Col md={4} className="mb-3">
                        <Form.Group className="mb-3">
                          <Form.Label>Tole</Form.Label>
                          <Form.Control
                            {...register("temporaryTole", {
                              required: "This is required",
                              minLength: {
                                value: 2,
                                message: "Min Length is 2",
                              },
                            })}
                            type="text"
                            placeholder=""
                            size="sm"
                          />
                          {errors.temporaryTole && (
                            <Form.Text className="text-danger">
                              {errors.temporaryTole.message}
                            </Form.Text>
                          )}
                        </Form.Group>
                      </Col>
                      <Col md={4} className="mb-3">
                        <Form.Group className="mb-3">
                          <Form.Label>House Number</Form.Label>
                          <Form.Control
                            {...register("temporaryHouseNumber", {
                              minLength: {
                                value: 1,
                                message: "Min Length is 1",
                              },
                            })}
                            type="text"
                            placeholder=""
                            size="sm"
                          />
                          {errors.temporaryHouseNumber && (
                            <Form.Text className="text-danger">
                              {errors.temporaryHouseNumber.message}
                            </Form.Text>
                          )}
                        </Form.Group>
                      </Col>

                      <hr />
                      <h5 className="mb-4">Other Information</h5>
                      <Col md={4} className="mb-3">
                        <Form.Group className="mb-3">
                          <Form.Label>PAN Number</Form.Label>
                          <Form.Control
                            {...register("pan", {
                              minLength: {
                                value: 4,
                                message: "Min Length is 4",
                              },
                            })}
                            type="text"
                            placeholder=""
                            size="sm"
                          />
                          {errors.pan && (
                            <Form.Text className="text-danger">
                              {errors.pan.message}
                            </Form.Text>
                          )}
                        </Form.Group>
                      </Col>
                      <Col md={4} className="mb-3">
                        <Form.Group className="mb-3">
                          <Form.Label>
                            Other Earning Family Member Relation
                          </Form.Label>
                          <Form.Select
                            aria-label="Other earning family relation dropdown"
                            {...register(
                              "otherEarningFamilyMemberRelation",
                              {}
                            )}
                            size="sm"
                          >
                            <option value={null}>{null}</option>
                            {relationOptions.map((item) => (
                              <option key={item.id} value={item.name}>
                                {item.value}
                              </option>
                            ))}
                          </Form.Select>
                          {errors.otherEarningFamilyMemberRelation && (
                            <Form.Text className="text-danger">
                              {errors.otherEarningFamilyMemberRelation.message}
                            </Form.Text>
                          )}
                        </Form.Group>
                      </Col>
                      <Col md={4} className="mb-3">
                        <Form.Group className="mb-3">
                          <Form.Label>
                            Other Earning Family Member Occupation
                          </Form.Label>
                          <Form.Control
                            {...register("otherEarningFamilyMemberOccupation", {
                              minLength: {
                                value: 4,
                                message: "Min Length is 4",
                              },
                            })}
                            type="text"
                            placeholder=""
                            size="sm"
                          />
                          {errors.otherEarningFamilyMemberOccupation && (
                            <Form.Text className="text-danger">
                              {
                                errors.otherEarningFamilyMemberOccupation
                                  .message
                              }
                            </Form.Text>
                          )}
                        </Form.Group>
                      </Col>
                      <hr />
                      <h5 className="mb-4">Politics Related</h5>
                      <Col md={4} className="mb-3">
                        <Form.Group className="mb-3">
                          <Form.Label>Political Exposed Person Name</Form.Label>
                          <Form.Control
                            {...register("pepName", {
                              minLength: {
                                value: 4,
                                message: "Min Length is 4",
                              },
                            })}
                            type="text"
                            placeholder=""
                            size="sm"
                          />
                          {errors.pepName && (
                            <Form.Text className="text-danger">
                              {errors.pepName.message}
                            </Form.Text>
                          )}
                        </Form.Group>
                      </Col>
                      <Col md={4} className="mb-3">
                        <Form.Group className="mb-3">
                          <Form.Label>
                            Relation type with the polticial person
                          </Form.Label>

                          <Form.Select
                            aria-label="Other earning family relation dropdown"
                            {...register("pepRelation", {})}
                            size="sm"
                          >
                            <option value={null}>{null}</option>
                            {relationOptions.map((item) => (
                              <option key={item.id} value={item.name}>
                                {item.value}
                              </option>
                            ))}
                          </Form.Select>
                          {errors.pepRelation && (
                            <Form.Text className="text-danger">
                              {errors.pepRelation.message}
                            </Form.Text>
                          )}
                        </Form.Group>
                      </Col>
                      <Col md={4} className="mb-3">
                        <Form.Group className="mb-3">
                          <Form.Label>
                            Political Exposed Person Position
                          </Form.Label>
                          <Form.Control
                            {...register("pepPosition", {
                              minLength: {
                                value: 4,
                                message: "Min Length is 4",
                              },
                            })}
                            type="text"
                            placeholder=""
                            size="sm"
                          />
                          {errors.pepPosition && (
                            <Form.Text className="text-danger">
                              {errors.pepPosition.message}
                            </Form.Text>
                          )}
                        </Form.Group>
                      </Col>

                      <hr />
                      <h5 className="mb-4">Nominee Details</h5>
                      <Col md={3} className="mb-3">
                        <Form.Group className="mb-3">
                          <Form.Label>Nominee Name</Form.Label>
                          <Form.Control
                            {...register("nomineeName", {
                              required: "This is required",
                              minLength: {
                                value: 4,
                                message: "Min Length is 4",
                              },
                            })}
                            type="text"
                            placeholder=""
                            size="sm"
                          />
                          {errors.nomineeName && (
                            <Form.Text className="text-danger">
                              {errors.nomineeName.message}
                            </Form.Text>
                          )}
                        </Form.Group>
                      </Col>
                      <Col md={3} className="mb-3">
                        <Form.Group className="mb-3">
                          <Form.Label>Address</Form.Label>
                          <Form.Control
                            {...register("nomineeAddress", {
                              required: "This is required",
                              minLength: {
                                value: 4,
                                message: "Min Length is 4",
                              },
                            })}
                            type="text"
                            placeholder=""
                            size="sm"
                          />
                          {errors.nomineeAddress && (
                            <Form.Text className="text-danger">
                              {errors.nomineeAddress.message}
                            </Form.Text>
                          )}
                        </Form.Group>
                      </Col>
                      <Col md={3} className="mb-3">
                        <Form.Group className="mb-3">
                          <Form.Label>Phone Number</Form.Label>
                          <Form.Control
                            {...register("nomineePhone", {
                              required: "This is required",
                              pattern: {
                                value: tenDigitRegexStartingWith9,
                                message:
                                  "Mobile Number should be of 10 digits beginning with 9",
                              },
                            })}
                            type="text"
                            placeholder=""
                            size="sm"
                          />
                          {errors.nomineePhone && (
                            <Form.Text className="text-danger">
                              {errors.nomineePhone.message}
                            </Form.Text>
                          )}
                        </Form.Group>
                      </Col>
                      <Col md={3} className="mb-3">
                        <Form.Group className="mb-3">
                          <Form.Label>Relation Type</Form.Label>

                          <Form.Select
                            aria-label="Nominee relation dropdown"
                            {...register("nomineeRelation", {
                              required: "This is required",
                            })}
                            size="sm"
                          >
                            <option value={null}>{null}</option>
                            {relationOptions.map((item) => (
                              <option key={item.id} value={item.name}>
                                {item.value}
                              </option>
                            ))}
                          </Form.Select>

                          {errors.nomineeRelation && (
                            <Form.Text className="text-danger">
                              {errors.nomineeRelation.message}
                            </Form.Text>
                          )}
                        </Form.Group>
                      </Col>

                      <hr />
                      <h5 className="mb-4">Finance Related(unknown)</h5>
                      <Col md={3} className="mb-3">
                        <Form.Group className="mb-3">
                          <Form.Label>Membership Goal</Form.Label>
                          <Form.Control
                            {...register("membershipGoal", {
                              required: "This is required",
                              minLength: {
                                value: 3,
                                message: "Min Length is 3",
                              },
                            })}
                            type="text"
                            placeholder=""
                            size="sm"
                          />
                          {errors.membershipGoal && (
                            <Form.Text className="text-danger">
                              {errors.membershipGoal.message}
                            </Form.Text>
                          )}
                        </Form.Group>
                      </Col>
                      <Col md={3} className="mb-3">
                        <Form.Group className="mb-3">
                          <Form.Label>Saving Scheme</Form.Label>
                          <Form.Control
                            {...register("savingScheme", {
                              required: "This is required",
                              minLength: {
                                value: 4,
                                message: "Min Length is 4",
                              },
                            })}
                            type="text"
                            placeholder=""
                            size="sm"
                          />
                          {errors.savingScheme && (
                            <Form.Text className="text-danger">
                              {errors.savingScheme.message}
                            </Form.Text>
                          )}
                        </Form.Group>
                      </Col>
                      <Col md={3} className="mb-3">
                        <Form.Group className="mb-3">
                          <Form.Label>Account Operation Type</Form.Label>
                          <Form.Control
                            {...register("accountOperationType", {
                              required: "This is required",
                              minLength: {
                                value: 4,
                                message: "Min Length is 4",
                              },
                            })}
                            type="text"
                            placeholder=""
                            size="sm"
                          />
                          {errors.accountOperationType && (
                            <Form.Text className="text-danger">
                              {errors.accountOperationType.message}
                            </Form.Text>
                          )}
                        </Form.Group>
                      </Col>
                      <Col md={3} className="mb-3">
                        <Form.Group className="mb-3">
                          <Form.Label>Yearly Family Income</Form.Label>
                          <Form.Control
                            {...register("yearlyFamilyIncome", {
                              required: "This is required",
                              pattern: {
                                value: positiveDigitsRegex,
                                message: "Only positive numbers allowed",
                              },
                            })}
                            type="text"
                            placeholder=""
                            size="sm"
                          />
                          {errors.yearlyFamilyIncome && (
                            <Form.Text className="text-danger">
                              {errors.yearlyFamilyIncome.message}
                            </Form.Text>
                          )}
                        </Form.Group>
                      </Col>
                      <Col md={3} className="mb-3">
                        <Form.Group className="mb-3">
                          <Form.Label>
                            Initial Share Investment Amount
                          </Form.Label>
                          <Form.Control
                            {...register("initialInvestmentShareAmount", {
                              required: "This is required",
                              pattern: {
                                value: positiveDigitsRegex,
                                message: "Only positive numbers allowed",
                              },
                            })}
                            type="text"
                            placeholder=""
                            size="sm"
                          />
                          {errors.initialInvestmentShareAmount && (
                            <Form.Text className="text-danger">
                              {errors.initialInvestmentShareAmount.message}
                            </Form.Text>
                          )}
                        </Form.Group>
                      </Col>
                      <Col md={3} className="mb-3">
                        <Form.Group className="mb-3">
                          <Form.Label>
                            Estimated Regular Deposit Amount
                          </Form.Label>
                          <Form.Control
                            {...register("estimatedRegularDepositAmount", {
                              required: "This is required",
                              pattern: {
                                value: positiveDigitsRegex,
                                message: "Only positive numbers allowed",
                              },
                            })}
                            type="text"
                            placeholder=""
                            size="sm"
                          />
                          {errors.estimatedRegularDepositAmount && (
                            <Form.Text className="text-danger">
                              {errors.estimatedRegularDepositAmount.message}
                            </Form.Text>
                          )}
                        </Form.Group>
                      </Col>
                      <Col md={3} className="mb-3">
                        <Form.Group className="mb-3">
                          <Form.Label>
                            Estimated Other Deposit Amount
                          </Form.Label>
                          <Form.Control
                            {...register("estimatedOtherDepositAmount", {
                              required: "This is required",
                              pattern: {
                                value: positiveDigitsRegex,
                                message: "Only positive numbers allowed",
                              },
                            })}
                            type="text"
                            placeholder=""
                            size="sm"
                          />
                          {errors.estimatedOtherDepositAmount && (
                            <Form.Text className="text-danger">
                              {errors.estimatedOtherDepositAmount.message}
                            </Form.Text>
                          )}
                        </Form.Group>
                      </Col>
                      <Col md={3} className="mb-3">
                        <Form.Group className="mb-3">
                          <Form.Label>
                            Estimated Annual Deposit Amount
                          </Form.Label>
                          <Form.Control
                            {...register("estimatedAnnualDepositAmount", {
                              required: "This is required",
                              pattern: {
                                value: positiveDigitsRegex,
                                message: "Only positive numbers allowed",
                              },
                            })}
                            type="text"
                            placeholder=""
                            size="sm"
                          />
                          {errors.estimatedAnnualDepositAmount && (
                            <Form.Text className="text-danger">
                              {errors.estimatedAnnualDepositAmount.message}
                            </Form.Text>
                          )}
                        </Form.Group>
                      </Col>
                      <Col md={3} className="mb-3">
                        <Form.Group className="mb-3">
                          <Form.Label>
                            Estimated Number of Transaction Per Year
                          </Form.Label>
                          <Form.Control
                            {...register(
                              "estimatedNumberOfTransactionPerYear",
                              {
                                required: "This is required",
                                pattern: {
                                  value: positiveDigitsRegex,
                                  message: "Only positive numbers allowed",
                                },
                              }
                            )}
                            type="text"
                            placeholder=""
                            size="sm"
                          />
                          {errors.estimatedNumberOfTransactionPerYear && (
                            <Form.Text className="text-danger">
                              {
                                errors.estimatedNumberOfTransactionPerYear
                                  .message
                              }
                            </Form.Text>
                          )}
                        </Form.Group>
                      </Col>

                      <Col md={3} className="mb-3">
                        <Form.Group className="mb-3">
                          <Form.Label>
                            Estimated Loan amount taken from Sahakari
                          </Form.Label>
                          <Form.Control
                            {...register(
                              "estimatedLoanAmountTakenFromSahakari",
                              {
                                required: "This is required",
                                pattern: {
                                  value: positiveDigitsRegex,
                                  message: "Only positive numbers allowed",
                                },
                              }
                            )}
                            type="text"
                            placeholder=""
                            size="sm"
                          />
                          {errors.estimatedLoanAmountTakenFromSahakari && (
                            <Form.Text className="text-danger">
                              {
                                errors.estimatedLoanAmountTakenFromSahakari
                                  .message
                              }
                            </Form.Text>
                          )}
                        </Form.Group>
                      </Col>

                      <hr />
                      <h5 className="mb-4">Referal Related</h5>
                      <Col md={3} className="mb-3">
                        <Form.Group className="mb-3">
                          <Form.Label>Referral Name</Form.Label>
                          <Form.Control
                            {...register("refferalName", {
                              minLength: {
                                value: 3,
                                message: "Min Length is 3",
                              },
                            })}
                            type="text"
                            placeholder=""
                            size="sm"
                          />
                          {errors.refferalName && (
                            <Form.Text className="text-danger">
                              {errors.refferalName.message}
                            </Form.Text>
                          )}
                        </Form.Group>
                      </Col>
                      <Col md={3} className="mb-3">
                        <Form.Group className="mb-3">
                          <Form.Label>Phone Number</Form.Label>
                          <Form.Control
                            {...register("refferalMemberNumber", {
                              minLength: {
                                value: 7,
                                message: "Min Length is 7",
                              },
                              pattern: {
                                value: positiveDigitsRegex,
                                message: "Only numbers are allowed",
                              },
                            })}
                            type="text"
                            placeholder=""
                            size="sm"
                          />
                          {errors.refferalMemberNumber && (
                            <Form.Text className="text-danger">
                              {errors.refferalMemberNumber.message}
                            </Form.Text>
                          )}
                        </Form.Group>
                      </Col>

                      <hr />
                      <h5 className="mb-4">Official Use Related</h5>
                      <Col md={3} className="mb-3">
                        <Form.Group className="mb-3">
                          <Form.Label>Official Name</Form.Label>
                          <Form.Control
                            {...register("officialName", {
                              required: "This is required",
                              minLength: {
                                value: 3,
                                message: "Min Length is 3",
                              },
                            })}
                            type="text"
                            placeholder=""
                            size="sm"
                          />
                          {errors.officialName && (
                            <Form.Text className="text-danger">
                              {errors.officialName.message}
                            </Form.Text>
                          )}
                        </Form.Group>
                      </Col>
                      <Col md={3} className="mb-3">
                        <Form.Group className="mb-3">
                          <Form.Label>Official Date</Form.Label>

                          <Controller
                            control={control}
                            name="officialDate"
                            render={({ field }) => (
                              <Datetime
                                timeFormat={false}
                                placeholderText="Select date"
                                onChange={(date) => field.onChange(date)}
                                selected={field.value}
                                renderInput={(
                                  props,
                                  openCalendar,
                                  closeCalendar
                                ) => {
                                  return (
                                    <InputGroup>
                                      <InputGroup.Text>
                                        <FontAwesomeIcon icon={faCalendarAlt} />
                                      </InputGroup.Text>
                                      <Form.Control
                                        {...register("officialDate", {
                                          required: "This is required",
                                        })}
                                        required
                                        type="text"
                                        value={
                                          field.value
                                            ? dayjs(field.value).format(
                                                "YYYY/MM/DD"
                                              )
                                            : ""
                                        }
                                        placeholder="yyyy/mm/dd"
                                        onFocus={openCalendar}
                                        autocomplete="off"
                                        size="sm"
                                      />
                                    </InputGroup>
                                  );
                                }}
                              />
                            )}
                          />

                          {errors.officialDate && (
                            <Form.Text className="text-danger">
                              {errors.officialDate.message}
                            </Form.Text>
                          )}
                        </Form.Group>
                      </Col>
                      <Col md={3} className="mb-3">
                        <Form.Group className="mb-3">
                          <Form.Label>Official Account Number</Form.Label>
                          <Form.Control
                            {...register("officialAccountNumber", {
                              required: "This is required",
                            })}
                            type="text"
                            placeholder=""
                            size="sm"
                          />
                          {errors.officialAccountNumber && (
                            <Form.Text className="text-danger">
                              {errors.officialAccountNumber.message}
                            </Form.Text>
                          )}
                        </Form.Group>
                      </Col>
                      <Col md={3} className="mb-3">
                        <Form.Group className="mb-3">
                          <Form.Label>Official Member Number</Form.Label>
                          <Form.Control
                            {...register("officialMemberNumber", {
                              required: "This is required",
                            })}
                            type="text"
                            placeholder=""
                            size="sm"
                          />
                          {errors.officialMemberNumber && (
                            <Form.Text className="text-danger">
                              {errors.officialMemberNumber.message}
                            </Form.Text>
                          )}
                        </Form.Group>
                      </Col>
                      <Col md={3} className="mb-3">
                        <Form.Group className="mb-3">
                          <Form.Label>Official Account Period</Form.Label>
                          <Form.Control
                            {...register("officialAccountPeriod", {
                              required: "This is required",
                            })}
                            type="text"
                            placeholder=""
                            size="sm"
                          />
                          {errors.officialAccountPeriod && (
                            <Form.Text className="text-danger">
                              {errors.officialAccountPeriod.message}
                            </Form.Text>
                          )}
                        </Form.Group>
                      </Col>
                      <Col md={3} className="mb-3">
                        <Form.Group className="mb-3">
                          <Form.Label>Official Intrest Rate</Form.Label>
                          <Form.Control
                            {...register("officialInterestRate", {
                              required: "This is required",
                            })}
                            type="text"
                            placeholder=""
                            size="sm"
                          />
                          {errors.officialInterestRate && (
                            <Form.Text className="text-danger">
                              {errors.officialInterestRate.message}
                            </Form.Text>
                          )}
                        </Form.Group>
                      </Col>
                      <Col md={3} className="mb-3">
                        <Form.Group className="mb-3">
                          <Form.Label>Official Saving Type</Form.Label>
                          <Form.Control
                            {...register("officialSavingType", {
                              required: "This is required",
                            })}
                            type="text"
                            placeholder=""
                            size="sm"
                          />
                          {errors.officialSavingType && (
                            <Form.Text className="text-danger">
                              {errors.officialSavingType.message}
                            </Form.Text>
                          )}
                        </Form.Group>
                      </Col>
                      <Col md={3} className="mb-3">
                        <Form.Group className="mb-3">
                          <Form.Label>Official Intrest Posting Type</Form.Label>
                          <Form.Control
                            {...register("officialInterestPostingType", {
                              required: "This is required",
                            })}
                            type="text"
                            placeholder=""
                            size="sm"
                          />
                          {errors.officialInterestPostingType && (
                            <Form.Text className="text-danger">
                              {errors.officialInterestPostingType.message}
                            </Form.Text>
                          )}
                        </Form.Group>
                      </Col>
                    </Row>
                    <div className="d-flex justify-content-end">
                      <Button
                        variant="primary"
                        className="m-1"
                        onClick={handleSubmit(onSubmit)}
                        disabled={isSubmitting}
                      >
                        {isSubmitting === true ? (
                          <Spinner animation="border" />
                        ) : (
                          "Update Customer"
                        )}
                      </Button>
                    </div>
                  </Form>
                </Card.Body>
              </Card>
            </Col>

            {/* /assign Customer to Collector */}
            <Col md={12} className={"mt-3"}>
              <Card border="light" className="bg-white shadow-sm mb-4 p-0">
                <Card.Body>
                  <h5 className="mb-4">Assign Collector</h5>

                  {isCollectorLoading ? (
                    <Spinner animation="border" />
                  ) : (
                    <Form onSubmit={submitHandler2}>
                      <Row>
                        <Col md={12} className="mb-3">
                          <Form.Group className="mb-3">
                            <Form.Label>
                              Assign a Collector to this Customer
                            </Form.Label>
                            <Form.Select
                              aria-label="Default select example"
                              value={collectorVal}
                              onChange={(e) => setCollectorVal(e.target.value)}
                            >
                              <option value={null}>{null}</option>
                              {changedCollectorData.map((item) => (
                                <option
                                  value={item.customerId}
                                  key={item.customerId}
                                >
                                  {item.name} - ({item.username})
                                </option>
                              ))}
                            </Form.Select>
                          </Form.Group>
                        </Col>
                      </Row>
                      <div className="d-flex justify-content-end">
                        <Button
                          variant="primary"
                          className="m-1"
                          onClick={submitHandler2}
                          disabled={isSubmitting}
                        >
                          {isSubmitting === true ? (
                            <Spinner animation="border" />
                          ) : (
                            "Assign this collector"
                          )}
                        </Button>
                      </div>
                    </Form>
                  )}
                </Card.Body>
              </Card>
            </Col>
          </>
        )}
      </>
    );
  }
}

export default EditCustomer;
